<template>
  <PageContent>
    <span class="summary-title">
      Please review and confirm your submission
    </span>
    <PanelV2
      type="w8"
      :title="sections[0].name"
      @nextClick="toNext()"
      mode="simple"
    >
      <template v-if="ekycStatus=='0'" v-slot:title-solt>
        <span class="btn-action" @click="toEdit('EditPayment')">EDIT</span>
      </template>
      <template v-slot:content-solt>
        <!-- series是列数 1/2/3列布局 -->
        <InfoBox :formdata="sections[0].data" :series="sections[0].columns.length"></InfoBox>
      </template>
    </PanelV2>

    <PanelV2
      type="w8"
      title="Personal Information"
      @nextClick="toNext()"
      mode="simple"
    >
      <template v-if="ekycStatus=='0'" v-slot:title-solt>
        <span class="btn-action" @click="toEdit('EditPersonalInfo2')">EDIT</span>
      </template>
      <template v-slot:content-solt>
        <InfoBox :formdata="sections[1].data" :series="sections[1].columns.length"></InfoBox>
      </template>
    </PanelV2>

    <PanelV2
      type="w8"
      title="Business Information"
      @nextClick="toNext()"
      mode="simple"
    >
      <template v-if="ekycStatus=='0'" v-slot:title-solt>
        <span class="btn-action" @click="toEdit('EditBusinessInfo2')">EDIT</span>
      </template>
      <template v-slot:content-solt>
        <InfoBox :formdata="businessData" :series="3" :agreements="agreementData"></InfoBox>
      </template>
    </PanelV2>

    <div class="with-two-panel">
      <PanelV2
        width="532px"
        title="BDO Settlement Account"
        @nextClick="toNext()"
        mode="simple"
      >
        <template v-if="ekycStatus=='0'|| !documentPsAreas.every(item=>!sections[2].isEditList.includes(item))" v-slot:title-solt>
          <span class="btn-action" @click="toEdit('EditSettlement')">EDIT</span>
        </template>
        <template v-slot:content-solt>
          <InfoBox :formdata="sections[2].data" :series="sections[2].columns.length"></InfoBox>
        </template>
      </PanelV2>

      <PanelV2
        width="532px"
        title="Document Submission"
        @nextClick="toNext()"
        mode="simple"
      >
        <template v-if="ekycStatus=='0' || !documentPsAreas.every(item=>!sections[3].isEditList.includes(item))" v-slot:title-solt>
          <span class="btn-action" @click="toEdit('EditDocument')">EDIT</span>
        </template>
        <template v-slot:content-solt>
          <InfoBox :formdata="sections[3].data" :series="sections[3].columns.length"></InfoBox>
        </template>
      </PanelV2>
    </div>

    <div class="summary-el-button-line">
      <el-button @click="$router.go(-1)">Back</el-button>
      <el-button type="primary" @click="doConfirm">Confirm</el-button>
    </div>
  </PageContent>
</template>

<script>
import InfoBox from "../components/InfoBox";
import { dateFormat } from "../../plugins/utils";
import API from "@/api";
import { provinceData, cityData } from "@/common-data/config.js"
import barangayData from "@/common-data/barangay-data";
export default {
  name: "PartnershipL",
  pRouter: "PartnershipK",
  components: {
    InfoBox,
  },
  data() {
    return {
      formData: {},
      // type : title标题 值传value上  , nomal普通左name右value  , wrap特殊换行 上name下value},
      sections: [
        { name: 'BDO Payment Solutions',
          editEntry: '/edit-payment',
          columns: [
            'digitalPayment',
            'physicalPayment',
            ''
          ],
          data: {left:[],middle:[],right:[]},
        },
        { name: 'Personal Information',
          editEntry: '/edit-personal-info',
          columns: [
            'personalInfo2',
            'email',
            ''
          ],
          data: {left:[],middle:[],right:[]},
        },
        { name: 'BDO Settlement Account',
          editEntry: '/edit-settlement',
          columns: [
            'settlementAccount'
          ],
          data: {left:[],middle:[],right:[]},
        },
        { name: 'Document Submission',
          editEntry: '/edit-document',
          columns: [
            'selfieWithIDPhoto',
            'secPhoto'
          ],
          data: {selfie:[], exterior:[], interior:[]},
        },
      ],

      agreementData:{},
      documentPsAreas: [],
      ekycStatus: '',
    };
  },
  created() {
    API.getBdoProcessData({
      ...this.formatCommitData()
    }).then((res) => {
      this.formData = res.obj
      //ekycStatus 0初始化，1待初审，2待复审，3审核通过，4待补充资料，5审核不通过，6需再次审核
      const { personalInfo, documentPsAreas=[], ekycStatus='0', processNo, businessDetails } = res.obj || {}
      const { newMchNameAgreement, privacyAgreementTime, merchantAgreementTime } = personalInfo || {}
      const { businessName } = businessDetails || {}
      this.agreementData = {
        'newMchNameAgreement': newMchNameAgreement || '',
        'privacyAgreementTime': dateFormat(privacyAgreementTime),
        'merchantAgreementTime': dateFormat(merchantAgreementTime),
        processNo: processNo || '4',
        registeredBusinessName: businessName,
      }
      this.documentPsAreas = documentPsAreas
      this.ekycStatus = ekycStatus
      this.formatColumn()
    })
  },
  computed: {
    businessData() {
      const data = this.formData
      let province = ''
      let city = ''
      let barangay = ''
      if (data.businessAddress) {
        province = provinceData.filter(val => val.value == data.businessAddress.province)[0].label
        city = cityData[data.businessAddress.province].filter(val => val.value == data.businessAddress.city)[0].label
        barangay = barangayData[data.businessAddress.city].filter(val => val.value == data.businessAddress.barangay)[0].label
      }
      let businessOwnership = data.businessOwnership ? data.businessOwnership.least20 == '1' ? 'Yes' : 'NO' : ''
      let value = {
        left: [
          {
            type: "title",
            name: "",
            value: "Business Details",
          },
          {
            type: "nomal",
            name: "Type of Merchant",
            value: "Partnership",
          },
          {
            type: 'documents',
          },
          {
            type: "nomal",
            name: "Registered Business Name",
            value: data.businessDetails && data.businessDetails.businessName,
          },
          {
            type: "nomal",
            name: "TIN",
            value: data.businessDetails && data.businessDetails.tin,
          },
          {
            type: "wrap",
            name: "Business Description",
            value: data.businessDetails && data.businessDetails.businessDescription,
          },
        ],
        middle: [
          {
            type: "title",
            name: "",
            value: "Business Address",
          },
          {
            type: 'nomal',
            name: 'Business Address',
            value: `${(data.businessAddress && data.businessAddress.streetAddress) ? (data.businessAddress.streetAddress + ',') : '' }${data.businessAddress && data.businessAddress.subdivision && (data.businessAddress.subdivision + ',') || ''}`,
          }, {
            type: 'nomal',
            name: '',
            value: `${barangay},${city},`,
          }, {
            type: 'nomal',
            name: '',
            value: `${province} ${data.businessAddress && data.businessAddress.zipCode}`,
          },
          {
            type: "title",
            name: "",
            value: "Beneficial Ownership",
          },
          {
            type: "nomal",
            name: "Owns 20% of the Business",
            value: businessOwnership ,
          },
        ],
        right: [
          {
            type: "title",
            name: "",
            value: "Authorized Signatories",
          },
        ],
      }
      let businessauthorized = {}
      if(data.businessauthorizedSignatories) {
        businessauthorized = data.businessauthorizedSignatories.businessauthorized.map((val, index) => ({type: "nomal", name: `Signatory ${index + 1}`, value: val}))
        value.right = [...value.right, ...businessauthorized]
      }
      return value
    }
  },
  methods: {
    toEdit(name) {
      this.$router.push({name})
    },
    doConfirm() {
      API.confirmBdoProcess({
        processNo: this?.formData?.processNo || '4',
        token: this.getCookieItem("token"),
      }).then((res) => {
        if (res.success) {
          this.$router.push({ path: "/finish-process" });
        }
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.page-content {
  .btn-action {
    cursor: pointer;
  }
  flex-direction: column;
  .panel-v2.content-area {
    margin: 8px 0;
    height: 100%;
  }
  .summary-title {
    align-self: start;
    margin-top: 48px;
    margin-bottom: 16px;
    width: 100%;
    text-align: left;
    font: normal normal normal 20px/24px Nunito-bold;
    letter-spacing: 0px;
    color: #2e2e2e;
  }
  .with-two-panel {
    display: flex;
    justify-content: space-between;
    width: 100%;
    .panel-v2.content-area {
      margin: 16px 0;
      height: 100%;
    }
  }
  .summary-el-button-line {
    display: flex;
    width: 100%;
    height: 112px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 16px #00000014;
    border-radius: 16px;
    justify-content: center;
    align-items: center;
    margin-top: 8px;
  }
}
</style>
